import React from "react";
import { StateDispatchProps } from "../state-dispatch.props";
import { QqBundleService } from "../../services/qq-bundle.service";
import { QqResultBoxControl } from "../../controls/qq-result-box.control";
import {
  ResGroupTypography,
  ResTextTypography,
} from "../../controls/qq-typohraphy.controls";
import imgNothing from "../../resources/img/nothing-suggested-illustration.svg";
import { Box } from "@mui/material";

export type RecommendationPaneProps = StateDispatchProps;

export const RecommendationPaneComponent: React.FunctionComponent<RecommendationPaneProps> =
  ({ state, dispatch }) => {
    const qqBundleServices = new QqBundleService(state.qqBundle);
    const { currentValues, currentOptions } = state;

    const recommendations =
      qqBundleServices.getFinalRecommendationIfExist(
        currentValues,
        currentOptions
      ) ?? qqBundleServices.getRecommendations(currentValues, currentOptions);

    const recommendationBoxes = (
      <React.Fragment>
        <ResGroupTypography>Google recommends &#8212; </ResGroupTypography>
        {recommendations.recommendation.map((r, index) => (
          <QqResultBoxControl
            key={index}
            result={r}
            isRecommendation={true}
            dispatch={dispatch}
            state={state}
          />
        ))}
        {recommendations.alsoGood.map((r, index) => (
          <QqResultBoxControl
            key={index}
            result={r}
            isRecommendation={false}
            dispatch={dispatch}
            state={state}
          />
        ))}
      </React.Fragment>
    );

    const nothingFoundBox = (
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Box
          sx={{
            margin: "auto",
            width: "300px",
            height: "300px",
            border: "1px solid rgba(224, 224, 224, 1)",
            borderRadius: "8px",
            marginTop: "10px",
            marginBottom: "10px",
            padding: "10px",
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              position: "relative",
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            <img
              src={imgNothing}
              alt={"No suggestions found"}
              style={{
                width: "130px",
                marginBottom: "14px",
              }}
            />
            <ResTextTypography
              sx={{
                marginTop: "14px",
              }}
            >
              Answer one or more survey questions to get recommendations
            </ResTextTypography>
          </Box>
        </Box>
      </Box>
    );

    return (
      <React.Fragment>
        {recommendations.recommendation.length > 0
          ? recommendationBoxes
          : nothingFoundBox}
      </React.Fragment>
    );
  };
